import React, { useEffect, useState } from 'react';
import { FaFilePdf } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Civic from '../../../assets/images/civic.png';
import SksLogo from '../../../assets/images/SKS-Logo-red.png';
import WestmeathLogo from '../../../assets/images/city-westmeath.png';
import CarlowLogo from '../../../assets/images/city-carlow.png';
import { callAddFont } from '../../../../src/assets/fonts/fa-solid-900-normal';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { useI18n } from '../../../i18n';
import { applyNotoSans, loadNotoSansFonts } from '../../../pdf/notoFont';


const TaskPDF = (props) => {
  const { t, tStatus, tCatalog } = useI18n();
	const [taskPDF, setTaskPDF] = useState([]);

  // Get Task from props
  useEffect(()=>{
    if (props.task) {
      setTaskPDF(props.task);
    }
  }, [props.task]);

  const manipulateDateString = (dateString) => {
    // Regular expression to match the date and time format
    const regex = /^(\d{2}\/\d{2}\/\d{4}), (\d{2}:\d{2}):\d{2}$/;

    // Replace the matched parts and format the string as desired
    const result = dateString.replace(regex, '$1 $2');

    return result;
  }

  // Parse Asset Logs
  const parseAssetLog = () => {
    let assetLog = [];   
    props.asset.log && props.asset.log.forEach((item) => {
        if (item.taskId === props.task.taskId){
            assetLog.push(item);
        }
    })
    // find users
    assetLog.forEach((item) => {
        const user = props.users.find(i => i.id === item.userId)
        if (user) item.user = user.name
    })
    
    //sort array desc
    assetLog.sort((a, b) => (a.date_note < b.date_note) ? 1 : -1);
    return assetLog;
  }

  const formatElapsed = (from, to) => {
    if (!from || !to) return '';
    const diff = new Date(new Date(to) - new Date(from));
    const days = diff.getUTCDate() - 1;
    const time = ("0"+diff.getUTCHours()).slice(-2) +":"+ ("0"+diff.getUTCMinutes()).slice(-2);
    if (days > 0) {
      return t(days === 1 ? 'exportDoc.dayTime' : 'exportDoc.daysTime', { n: days, time });
    }
    return time;
  }

  const chargeableLabel = (value) => {
    let key = 'Fixed';
    if (value === true || value === 'true' || value === 'Chargeable') key = 'Chargeable';
    else if (value === 'Quoted') key = 'Quoted';
    else if (value === false || value === 'false' || value === 'Fixed') key = 'Fixed';
    return tCatalog(key);
  }

  const slaUnit = (category) => (category === 'Reactive' ? tCatalog('hrs') : tCatalog('days'));

  // Parse task into a local copy so stored values on the live task are not changed
  const parseTask = (source) => {
    const task = { ...(source || {}) };
    switch (task.task_status) {
      case 'Created': 
        task.taskStatusColor = "#ffc107";
        break;
      case 'Accepted': 
        task.taskStatusColor = "#dc3545";
        break;
      case 'Started': 
        task.taskStatusColor = "#007bff";
        break;
      case 'Completed': 
        task.taskStatusColor = "#28a745";
        break;
      case 'WIP': 
        task.taskStatusColor = "#17a2b8";
        break;
      default: 
        task.taskStatusColor = "#343a40";
        break;
    }

    if (task.date_created){
      task.date_created_str = manipulateDateString(new Date(task.date_created).toLocaleString('en-GB'));
    }

    if (task.date_accepted){
      task.date_accepted_str = manipulateDateString(new Date(task.date_accepted).toLocaleString('en-GB'));
    }

    if (task.date_completed){
      task.date_completed_str = manipulateDateString(new Date(task.date_completed).toLocaleString('en-GB'));
    }

    if (task.date_started){
      task.date_started_str = manipulateDateString(new Date(task.date_started).toLocaleString('en-GB'));
    }

    task.sla_attend_work = formatElapsed(task.date_created, task.date_started);
    task.sla_repair_work = formatElapsed(task.date_started, task.date_completed);
    task.category_str = tCatalog(task.category);
    task.type_fault_str = tCatalog(task.type_fault);
    task.urgent_fault_str = tCatalog(task.urgent_fault);
    task.task_status_str = tStatus(task.task_status);
    task.chargeable_str = chargeableLabel(task.chargeable);

    if (task.sla_attend) {
      task.sla_attend_str = task.sla_attend + ' ' + slaUnit(task.category);
    }

    if (task.sla_repair) {
      task.sla_repair_str = task.sla_repair + ' ' + slaUnit(task.category);
    }

    if (task.user_completed && Array.isArray(props.users)){
      const usr_comp = props.users.find(i => i.id === task.user_completed)
      if (usr_comp) task.user_completed_str = usr_comp.name;
    }
    if (task.user_created && Array.isArray(props.users)){
        const usr_comp = props.users.find(i => i.id === task.user_created)
        if (usr_comp) task.user_created_str = usr_comp.name;
    }

    task.hp_site_str = props.asset && props.asset.hp_site === true ? t('assets.high') : t('assets.low');
    return task;
  }

  const drawLine = (doc, xPos, yPos, pageWidth) => {
    doc.setLineWidth(1);
    doc.setDrawColor(230, 230, 230);
    doc.line(xPos, yPos, pageWidth - 40, yPos);
    doc.setDrawColor(0, 0, 0);
  }

  const generatePDF = async () => {
    const task = parseTask(taskPDF);
    await downloadPDF(task);
  }

  const downloadPDF = async (task) => {
    jsPDF.API.events.push(["addFonts", callAddFont]);
    var doc = new jsPDF('p','pt');
    let pdfFont = 'helvetica';
    try {
      const fonts = await loadNotoSansFonts();
      pdfFont = applyNotoSans(doc, fonts);
    } catch (err) {
      pdfFont = 'helvetica';
    }
    doc.setFont(pdfFont, 'normal');

    // Initial variables
    var yPos = 100;
    var xPos = 40;
    const pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    const pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    const pageWidthWithoutMargins = pageWidth - 40 * 2;

    var lineHeight = (doc.getLineHeight() * 1.25) / doc.internal.scaleFactor;

    /* __________________________________________________________________________________________________ */

    // Add a logo to the document (per-environment logo)
    const isSksEnv = process.env.REACT_APP_GLOB_APP_ENV === 'sks';
    const isWestmeathEnv = process.env.REACT_APP_GLOB_APP_ENV === 'westmeath';
    const isCarlowEnv = process.env.REACT_APP_GLOB_APP_ENV === 'carlow';
    let logoImage = Civic;
    let logoWidth = 151;
    let logoHeight = 50;
    let logoY = 20;
    if (isSksEnv) {
      logoImage = SksLogo;
      logoWidth = 100;
      logoHeight = 130;
      logoY = 1;
    } else if (isWestmeathEnv) {
      logoImage = WestmeathLogo;
      logoWidth = 140;
      logoHeight = 60;
      logoY = 20;
    } else if (isCarlowEnv) {
      logoImage = CarlowLogo;
      logoWidth = 210;
      logoHeight = 96;
      logoY = 12;
    }
    doc.addImage(logoImage, "PNG", 20, logoY, logoWidth, logoHeight, '', 'FAST');
    // For SKS, move content down so it doesn't overlap the taller logo
    if (isSksEnv) {
      yPos += 10;
    }
    if (isCarlowEnv) {
      yPos += 28;
    }
    
    /* __________________________________________________________________________________________________ */

    // Task Reference - Title
    const refLabel = t('exportDoc.taskRef');
    doc.setFont(pdfFont, 'normal');
    doc.setFontSize(10);
    const refBoxW = Math.max(80, Math.min(120, doc.getTextWidth(refLabel) + 18));
    const refBoxX = xPos;
    const refBoxY = yPos - 10;
    const refCenterX = refBoxX + refBoxW / 2;
    doc.setFillColor(248, 249, 250);
    doc.roundedRect(refBoxX, refBoxY, refBoxW, 70, 10, 10, 'F');
    doc.setDrawColor('#ffc107');
    doc.roundedRect(refBoxX, refBoxY, refBoxW, 70, 10, 10, 'S');
    doc.setTextColor('#084981');
    doc.text(refLabel, refCenterX, yPos + 18, {
    align: 'center',
    });
    doc.setFont(pdfFont, 'bold');
    doc.setFontSize(16);
    doc.setTextColor('#000000');
    doc.text(task.task_ref ? task.task_ref + '' : '', refCenterX, yPos + 40, {
    align: 'center',
    });

    // Site Reference - Title
    doc.autoTable({
      theme: 'plain',
      styles: { font: pdfFont, valign: 'middle', fontSize: 15, fontStyle: 'bold', textColor: '#343a40', halign: 'left' },
      body: [
        [
          { content: props.asset.site_ref + ' - ' + props.asset.site_address, styles: { minCellHeight: 70 } },
        ],
        
      ],
      startY: yPos - 10,
      margin: { left: refBoxX + refBoxW + 12 }
    });
    yPos += lineHeight;

    doc.setTextColor(0, 0, 0);

    yPos += lineHeight + 60;

    /* _______________________________________________________________ */

    // Site Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(15);
    doc.setFont(pdfFont, 'bold');
    doc.text(t('fields.siteDetails'), xPos, yPos, {
      align: 'left',
    });
    yPos += lineHeight / 2;

    doc.autoTable({
      theme: 'plain',
      styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
      headStyles: {
        textColor: '#084981',
        cellWidth: pageWidthWithoutMargins / 3,
        halign: 'left',
      },
      bodyStyles: { textColor: 'black', halign: 'left' },
      head: [
        [
          {
            content: t('fields.siteRef'),
          },
          {
            content: t('exportDoc.municipalDistrict'),
          },
          {
            content: t('fields.siteAddress'),
          },
        ],
      ],
      body: [
        [
          { content: props.asset.site_ref ? props.asset.site_ref : '' },
          { content: props.asset.district ? props.asset.district : '' },
          { content: props.asset.site_address ? props.asset.site_address : '' },
        ],
        [
          {
            content: t('exportDoc.dateCreated'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
          {
            content: t('exportDoc.user'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
        ],
        [
          { content: task.date_created_str ? task.date_created_str : '' },
          { content: task.user_created_str ? task.user_created_str : '' },
        ]
      ],
      startY: yPos,
    });
    yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

    drawLine(doc, xPos, yPos, pageWidth);

    yPos += lineHeight;

    /* _______________________________________________________________ */

    // Contract Requirements
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(15);
    doc.setFont(pdfFont, 'bold');
    doc.text(t('exportDoc.contractRequirements'), xPos, yPos, {
      align: 'left',
    });
    yPos += lineHeight / 2;

    doc.autoTable({
      theme: 'plain',
      styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
      headStyles: {
        textColor: '#084981',
        cellWidth: pageWidthWithoutMargins / 3,
        halign: 'left',
      },
      bodyStyles: { textColor: 'black', halign: 'left' },
      head: [
        [
          {
            content: t('fields.prioritySite'),
          },
          {
            content: t('common.classification'),
          },
          {
            content: t('exportDoc.slaAttendSite'),
          },
        ],
      ],
      body: [
        [
          { content: task.hp_site_str ? task.hp_site_str : '' },
          { content: task.urgent_fault_str ? task.urgent_fault_str : '' },
          { content: task.sla_attend_str ? task.sla_attend_str : '' },
        ],
        [
          {
            content: t('exportDoc.slaCompleteTask'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
          {
            content: t('fields.chargeable'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
        ],
        [
          { content: task.sla_repair_str ? task.sla_repair_str : '' },
          { content: task.chargeable_str ? task.chargeable_str : '' },
        ],
      ],
      startY: yPos,
    });
    yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

    drawLine(doc, xPos, yPos, pageWidth);

    yPos += lineHeight;

    /* _______________________________________________________________ */

    yPos += lineHeight;
    // Contractor Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(15);
    doc.setFont(pdfFont, 'bold');
    doc.text(t('fields.contractorDetails'), xPos, yPos, {
      align: 'left',
    });
    yPos += lineHeight / 2;

    doc.autoTable({
      theme: 'plain',
      styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
      headStyles: {
        textColor: '#084981',
        cellWidth: pageWidthWithoutMargins / 3,
        halign: 'left',
      },
      bodyStyles: { textColor: 'black', halign: 'left' },
      head: [
        [
          {
            content: t('common.contractor'),
          },
          {
            content: t('exportDoc.engineer'),
          },
          {
            content: t('exportDoc.taskStatus'),
          },
        ],
      ],
      body: [
        [
          { content: task.contractor ? task.contractor : '' },
          {
            content: task.user_completed_str
              ? task.user_completed_str
              : '',
          },
          {
            content: task.task_status_str ? task.task_status_str : '',
            styles: { fillColor: task.taskStatusColor },
          },
        ],
        [
          {
            content: t('exportDoc.dateAccepted'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
          {
            content: t('exportDoc.dateStarted'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
          {
            content: t('exportDoc.dateCompleted'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
        ],
        [
          { content: task.date_accepted_str ? task.date_accepted_str : '' },
          { content: task.date_started_str ? task.date_started_str : '' },
          { content: task.date_completed_str ? task.date_completed_str : '' },
        ],
        [
          {
            content: t('exportDoc.attendSite'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
          {
            content: t('exportDoc.completeTask'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
          },
        ],
        [
          { content: task.sla_attend_work ? task.sla_attend_work : '' },
          { content: task.sla_repair_work ? task.sla_repair_work : '' },
        ],
      ],
      startY: yPos,
    });
    yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

    /* _______________________________________________________________ */

    // Add a new page
    doc.addPage('a4', 'p');
    yPos = 40;

    /* _______________________________________________________________ */

    yPos += lineHeight;

    // Work Required
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(15);
    doc.setFont(pdfFont, 'bold');
    doc.text(t('fields.workRequired'), xPos, yPos, {
      align: 'left',
    });
    yPos += lineHeight / 2;

    doc.autoTable({
      theme: 'plain',
      styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
      headStyles: {
        textColor: '#084981',
        cellWidth: pageWidthWithoutMargins / 3,
        halign: 'left',
      },
      bodyStyles: { textColor: 'black', halign: 'left' },
      head: [
        [
          {
            content: t('fields.contractorRef'),
          },
          {
            content: t('common.category'),
          },
          {
            content: t('exportDoc.typeFault'),
          },
        ],
      ],
      body: [
        [
          { content: task.contractor_ref ? task.contractor_ref : '' },
          { content: task.category_str ? task.category_str : '' },
          { content: task.type_fault_str ? task.type_fault_str : '' },
        ],
        [
          {
            content: t('exportDoc.faultDescription'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
            colSpan: 3
          },
        ],
        [
          { content: task.fault_description ? task.fault_description : '',
            colSpan: 3 
          },
        ],
        [
          {
            content: t('fields.workCarriedOut'),
            styles: { textColor: '#084981', fontStyle: 'bold' },
            colSpan: 3
          },
        ],
        [
          { content: task.work_completed ? task.work_completed : '',
            colSpan: 3
          },
        ],
      ],
      startY: yPos,
    });
    yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

    drawLine(doc, xPos, yPos, pageWidth);

    yPos += lineHeight;

    /* _______________________________________________________________ */

    // Materials
    if (task.materials_description && task.materials_description !== '' && task.materials_description !== '-') {
      yPos += lineHeight;

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(15);
      doc.setFont(pdfFont, 'bold');
      doc.text(t('fields.materials'), xPos, yPos, {
        align: 'left',
      });
      yPos += lineHeight / 2;

      doc.autoTable({
        theme: 'plain',
        styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
        bodyStyles: { textColor: 'black', halign: 'left', fontStyle: 'bold' },
        body: [
          [
            {
              content: task.materials_description
                ? task.materials_description
                : t('exportDoc.none'),
            },
          ],
        ],
        startY: yPos,
      });
      yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

      drawLine(doc, xPos, yPos, pageWidth);

      yPos += lineHeight;
    }

    /* _______________________________________________________________ */

    // Costs
    if (task.materials || task.callout_subtotal || task.onsite_subtotal || task.total_cost) {
      yPos += lineHeight;

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(15);
      doc.setFont(pdfFont, 'bold');
      doc.text(t('exportDoc.costs'), xPos, yPos, {
        align: 'left',
      });
      yPos += lineHeight / 2;

      doc.autoTable({
        theme: 'plain',
        styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
        headStyles: {
          textColor: '#084981',
          cellWidth: pageWidthWithoutMargins,
          halign: 'right',
        },
        columnStyles: { 0: { fontStyle: 'bold', halign: 'left' } },
        bodyStyles: { textColor: 'black', halign: 'right' },
        head: [
          [
            {
              content: '',
              styles: { cellWidth: pageWidthWithoutMargins * 0.25 },
            },
            {
              content: t('exportDoc.number'),
              styles: { cellWidth: pageWidthWithoutMargins * 0.2 },
            },
            {
              content: t('fields.rate'),
              styles: { cellWidth: pageWidthWithoutMargins * 0.2 },
            },
            {
              content: t('fields.subtotal'),
              styles: { cellWidth: pageWidthWithoutMargins * 0.2 },
            },
          ],
        ],
        body: [
          [
            {
              content: t('fields.materials'),
            },
            {
              content: '-',
            },
            {
              content: '-',
            },
            {
              content: task.materials ? '€ ' + task.materials.toFixed(2) : '-',
            },
          ],
          [
            {
              content: t('fields.callOutFee'),
            },
            {
              content: task.callout_nr ? task.callout_nr : '-',
            },
            {
              content: task.callout_rate ? '€ ' + task.callout_rate.toFixed(2) : '-',
            },
            {
              content: task.callout_subtotal ? '€ ' + task.callout_subtotal.toFixed(2) : '-',
            },
          ],
          [
            {
              content: t('exportDoc.onSiteLabourCost'),
            },
            {
              content: task.onsite_nr ? task.onsite_nr : '-',
            },
            {
              content: task.onsite_rate ? '€ ' + task.onsite_rate.toFixed(2) : '-',
            },
            {
              content: task.onsite_subtotal ? '€ ' + task.onsite_subtotal.toFixed(2) : '-',
            },
          ],
          [
            {
              content: t('fields.totalCost'),
              styles: { fontSize: 18 },
              colSpan: 2,
            },
            {
              content: task.total_cost ? '€ ' + task.total_cost.toFixed(2) : '-',
              styles: { fontSize: 18, fontStyle: 'bold' },
              colSpan: 2,
            },
          ],
        ],
        startY: yPos,
      });
      yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

      drawLine(doc, xPos, yPos, pageWidth);

      yPos += lineHeight;
    }

    /* _______________________________________________________________ */

    yPos += lineHeight;

    // Routine Inspection
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(15);
    doc.setFont(pdfFont, 'bold');
    doc.text(t('fields.routineInspection'), xPos, yPos, {
      align: 'left',
    });
    yPos += lineHeight / 2;

    const riLine = (section, key) => {
      const label = t(key);
      return section && section.problem ? label + '\n - ' + section.problem : label;
    };

    if (task.ri) {
      doc.autoTable({
        theme: 'plain',
        styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
        bodyStyles: { textColor: 'black', halign: 'left', fontStyle: 'bold' },
        columnStyles: {
          0: { halign: 'right' },
          2: { halign: 'right' },
          4: { halign: 'right' },
        },
        body: [
          [
            {
              content: task.ri.q1_lamps.ok ? '\u2714' : '\u2715',
              styles: {
                cellWidth: (pageWidthWithoutMargins / 3) * 0.2,
                font: 'fa-solid-900',
                textColor: task.ri.q1_lamps.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q1_lamps, 'ri.lampsFault'),
              styles: { cellWidth: (pageWidthWithoutMargins / 3) * 0.8 },
            },
            {
              content: task.ri.q2_signal_heads.ok
                ? '\u2714'
                : '\u2715',
              styles: {
                cellWidth: (pageWidthWithoutMargins / 3) * 0.2,
                font: 'fa-solid-900',
                textColor: task.ri.q2_signal_heads.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q2_signal_heads, 'ri.signalHeads'),
              styles: { cellWidth: (pageWidthWithoutMargins / 3) * 0.8 },
            },
            {
              content: task.ri.q3_caps_bungs.ok
                ? '\u2714'
                : '\u2715',
              styles: {
                cellWidth: (pageWidthWithoutMargins / 3) * 0.2,
                font: 'fa-solid-900',
                textColor: task.ri.q3_caps_bungs.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q3_caps_bungs, 'ri.poleCaps'),
              styles: { cellWidth: (pageWidthWithoutMargins / 3) * 0.8 },
            },
          ],
          [
            {
              content: task.ri.q4_push_buttons.ok
                ? '\u2714'
                : '\u2715',
              styles: {
                font: 'fa-solid-900',
                textColor: task.ri.q4_push_buttons.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q4_push_buttons, 'ri.pushButtons'),
            },
            {
              content: task.ri.q5_controller.ok
                ? '\u2714'
                : '\u2715',
              styles: {
                font: 'fa-solid-900',
                textColor: task.ri.q5_controller.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q5_controller, 'ri.controllers'),
            },
            {
              content: task.ri.q6_detection.ok ? '\u2714' : '\u2715',
              styles: {
                font: 'fa-solid-900',
                textColor: task.ri.q6_detection.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q6_detection, 'ri.detection'),
            },
          ],
          [
            {
              content: task.ri.q7_log_book.ok ? '\u2714' : '\u2715',
              styles: {
                font: 'fa-solid-900',
                textColor: task.ri.q7_log_book.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q7_log_book, 'ri.logBook'),
            },
            {
              content: task.ri.q8_site_issues.ok
                ? '\u2714'
                : '\u2715',
              styles: {
                font: 'fa-solid-900',
                textColor: task.ri.q8_site_issues.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q8_site_issues, 'ri.siteIssues'),
            },
            {
              content: task.ri.q9_door.ok ? '\u2714' : '\u2715',
              styles: {
                font: 'fa-solid-900',
                textColor: task.ri.q9_door.ok
                  ? '#28a745'
                  : '#dc3545',
              },
            },
            {
              content: riLine(task.ri.q9_door, 'ri.doorClosed'),
            },
          ],
        ],
        startY: yPos,
      });
      yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;
    } else {
      yPos += lineHeight;
      doc.setFont(pdfFont, 'bold');
      doc.setTextColor('#000000');
      doc.text(t('exportDoc.none'), pageWidth / 2, yPos, {
        align: 'center',
      });
      doc.setFont(pdfFont, 'normal');
      yPos += lineHeight;
    }
    yPos += lineHeight;

    /* _______________________________________________________________ */

    // Add a new page
    doc.addPage('a4', 'p');
    yPos = 40;

    /* _______________________________________________________________ */

    yPos += lineHeight;

    // Site History
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(15);
    doc.setFont(pdfFont, 'bold');
    doc.text(t('taskView.siteHistory'), xPos, yPos, {
      align: 'left',
    });
    yPos += lineHeight / 2;

    const generateLogRows = () => {
      let rows = [];
      for (let log of parseAssetLog()) {
        rows.push(
          [
            {
              content: manipulateDateString(new Date(log.date_note).toLocaleString('en-GB')),
              styles: {
                cellWidth: pageWidthWithoutMargins * 0.35,
                fillColor: '#f7f7f7',
                textColor: 'rgb(83, 50, 9)',
                halign: 'left',
              },
            },
            {
              content: log.user,
              styles: {
                cellWidth: pageWidthWithoutMargins * 0.65,
                fillColor: '#f7f7f7',
                textColor: 'rgb(83, 50, 9)',
                halign: 'left',
              },
            },
          ],
          [
            {
              content: log.note,
              styles: {
                halign: 'left',
              },
              colSpan: 2,
            },
          ]
        );
      }
      return rows;
    };

    doc.autoTable({
      theme: 'plain',
      styles: { font: pdfFont, valign: 'middle', fontSize: 12 },
      bodyStyles: {
        textColor: 'black',
        halign: 'center',
        cellPadding: 10,
      },
      // To add images
      // didDrawCell: function (data) {
      //   if (data.column.index === 0 && data.cell.section === 'body') {
      //     var td = data.cell.raw;
      //     console.log(data);
      //     var img = props.asset.log[1].image_url;
      //     var dim = data.cell.height - data.cell.padding('vertical');
      //     console.log(data.cell.x);
      //     console.log(data.cell.y);
      //     console.log(dim);
      //     //doc.addImage(img, 'JPEG', data.cell.x, data.cell.y, dim, dim);
      //   }
      // },
      body: generateLogRows(),
      startY: yPos,
    });
    yPos += doc.previousAutoTable.finalY - yPos + lineHeight - 10;

    drawLine(doc, xPos, yPos, pageWidth);

    yPos += lineHeight;

    /* _______________________________________________________________ */

    // Save the document
    var currentDate = new Date().toISOString().slice(0, 10);
    var fileName = task.task_ref + " - " + props.asset.site_ref + ".pdf";
    doc.save(fileName);
  }

  return (
    <Button
      variant="outline-secondary"
      size="sm"
      className="task-action-btn"
      onClick={() => generatePDF()}
    >
      <FaFilePdf /> {t('exportDoc.pdf')}
    </Button>
  );
}


export default TaskPDF;
